var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.1053C8 9.5495 8.22078 9.01651 8.61376 8.62352C9.00674 8.23054 9.53974 8.00977 10.0955 8.00977H16.9045C17.1797 8.00977 17.4522 8.06397 17.7064 8.16928C17.9607 8.27458 18.1917 8.42894 18.3862 8.62352C18.5808 8.81811 18.7352 9.04911 18.8405 9.30335C18.9458 9.55759 19 9.83008 19 10.1053V16.9143C19 17.1895 18.9458 17.4619 18.8405 17.7162C18.7352 17.9704 18.5808 18.2014 18.3862 18.396C18.1917 18.5906 17.9607 18.7449 17.7064 18.8503C17.4522 18.9556 17.1797 19.0098 16.9045 19.0098H10.0955C9.82031 19.0098 9.54782 18.9556 9.29359 18.8503C9.03935 18.7449 8.80834 18.5906 8.61376 18.396C8.41917 18.2014 8.26482 17.9704 8.15951 17.7162C8.0542 17.4619 8 17.1895 8 16.9143V10.1053Z",
    stroke: "#4776E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74963 16.0098C5.52222 15.8701 5.33307 15.6678 5.20141 15.4235C5.06974 15.1792 5.00025 14.9016 5 14.6189V6.61128C5 5.73045 5.66667 5.00977 6.48148 5.00977H13.8889C14.4444 5.00977 14.7467 5.31806 15 5.81052",
    stroke: "#4776E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.2d85edf751c13e029b0ed762c9600ade.svg";
export { ForwardRef as ReactComponent };